import { render } from "./DanhSachLenh.vue?vue&type=template&id=e38db122&scoped=true"
import script from "./DanhSachLenh.vue?vue&type=script&lang=js"
export * from "./DanhSachLenh.vue?vue&type=script&lang=js"

import "./DanhSachLenh.vue?vue&type=style&index=0&id=e38db122&scoped=true&lang=css"
import "./DanhSachLenh.vue?vue&type=style&index=1&id=e38db122&lang=scss&scoped=true"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e38db122"]])

export default __exports__